import { ControlReviewDao } from "../dao";
import { JsonObject } from "../../types";
import {
  ControlReview,
  AgentSelfStatistics,
  DecisionsStatistics,
  ControlResultFps,
  ControlResultNfps,
  ControlAdditionalData
} from "../model";
import { Control, SkipControlBody } from "../../controlReview/swagger";

export class ControlReviewService {
  private readonly _controlReviewDao: ControlReviewDao;

  public constructor(controlReviewDao: ControlReviewDao) {
    this._controlReviewDao = controlReviewDao;
  }

  public async emitFps(
    controlId: string,
    payload?: ControlResultFps
  ): Promise<void> {
    try {
      await this._controlReviewDao.emitFps(controlId, payload);
    } catch (error) {
      throw error;
    }
  }

  public async emitNfps(
    controlId: string,
    payload?: ControlResultNfps
  ): Promise<void> {
    try {
      await this._controlReviewDao.emitNfps(controlId, payload);
    } catch (error) {
      throw error;
    }
  }

  public async skipControl(
    controlId: string,
    payload?: SkipControlBody
  ): Promise<void> {
    try {
      return await this._controlReviewDao.skipControl(controlId, payload);
    } catch (error) {
      throw error;
    }
  }

  public async getControlReview(force?: number): Promise<ControlReview> {
    try {
      return await this._controlReviewDao.getControlReview(force);
    } catch (error) {
      throw error;
    }
  }

  public async saveControlReview(
    controlId: string,
    payload?: ControlAdditionalData
  ) {
    try {
      return await this._controlReviewDao.saveControlReview(controlId, payload);
    } catch (error) {
      throw error;
    }
  }

  public async sendFollower(
    controlId: string,
    payload?: JsonObject
  ): Promise<JsonObject> {
    try {
      return await this._controlReviewDao.sendFollower(controlId, payload);
    } catch (error) {
      throw error;
    }
  }

  public async getAgentSelfStatistics(): Promise<AgentSelfStatistics> {
    try {
      return await this._controlReviewDao.getAgentSelfStatistics();
    } catch (error) {
      throw error;
    }
  }

  public async getDayAgentsStatistics(): Promise<JsonObject[]> {
    try {
      return await this._controlReviewDao.getDayAgentsStatistics();
    } catch (error) {
      throw error;
    }
  }

  public async getDayDecisionsStatistics(): Promise<DecisionsStatistics> {
    try {
      return await this._controlReviewDao.getDayDecisionsStatistics();
    } catch (error) {
      throw error;
    }
  }

  public async getDayHourlyStatistics(): Promise<JsonObject[]> {
    try {
      return await this._controlReviewDao.getDayHourlyStatistics();
    } catch (error) {
      throw error;
    }
  }

  public async getDayLapiStatistics(): Promise<JsonObject[]> {
    try {
      return await this._controlReviewDao.getDayLapiStatistics();
    } catch (error) {
      throw error;
    }
  }
}

export default ControlReviewService;
